require('es6-promise/auto');

import polyfills from './polyfills';
import './vendor/modernizr/modernizr.custom.js';

// @ts-ignore
declare var __webpack_public_path__: string;

if (window.webpack_public_path) {
	// @ts-ignore
	__webpack_public_path__ = window.webpack_public_path;
}

async function main() {
	await polyfills();
	await import(/* webpackChunkName: "main" */ './main');
}

main();
//	.catch(() => {
//	throw new Error(`Something went wrong when loading polyfills or main.ts scripts`);
//});
